import { ref, type Ref } from 'vue';

import WelcomePage from '@/views/WelcomePage.vue';
import ValidationPage from '@/views/ValidationPage.vue';
import CheckoutDetailsPage from '@/views/CheckoutDetailsPage.vue';
import ViewBolPage from '@/views/ViewBolPage.vue';

export enum CheckoutFlowStep {
  WelcomePage = 'WelcomePage',
  ValidationPage = 'ValidationPage',
  CheckoutDetailsPage = 'CheckoutDetailsPage',
  ViewBolPage = 'ViewBolPage'
}

const step = ref<CheckoutFlowStep>(CheckoutFlowStep.WelcomePage);

export function useCheckoutFlow() {
  const getCurrentStepComponent = (step: Ref<CheckoutFlowStep>) => {
    switch (step.value) {
      case CheckoutFlowStep.WelcomePage:
        return WelcomePage;
      case CheckoutFlowStep.ValidationPage:
        return ValidationPage;
      case CheckoutFlowStep.CheckoutDetailsPage:
        return CheckoutDetailsPage;
      case CheckoutFlowStep.ViewBolPage:
        return ViewBolPage;
      default:
        return null;
    }
  };

  const validateStep = (step: CheckoutFlowStep) => {
    switch (step) {
      case CheckoutFlowStep.WelcomePage:
        // No validation needed for Welcome step
        return true;
      case CheckoutFlowStep.ValidationPage:
        // Add validation logic for Validation step
        return true;
      case CheckoutFlowStep.CheckoutDetailsPage:
        // Add validation logic for Checkout Details step
        return true;
      case CheckoutFlowStep.ViewBolPage:
        // Add validation logic for View BOL step
        return true;
      default:
        return false;
    }
  };

  const goToNextStep = (): CheckoutFlowStep => {
    switch (step.value) {
      case CheckoutFlowStep.WelcomePage:
        step.value = CheckoutFlowStep.ValidationPage;
        break;
      case CheckoutFlowStep.ValidationPage:
        step.value = CheckoutFlowStep.CheckoutDetailsPage;
        break;
      case CheckoutFlowStep.CheckoutDetailsPage:
        step.value = CheckoutFlowStep.ViewBolPage;
        break;
      case CheckoutFlowStep.ViewBolPage:
        // Already at the last step, do nothing or loop back to the first step
        break;
    }
    return step.value;
  };

  const goToPreviousStep = (): CheckoutFlowStep => {
    switch (step.value) {
      case CheckoutFlowStep.ValidationPage:
        step.value = CheckoutFlowStep.WelcomePage;
        break;
      case CheckoutFlowStep.CheckoutDetailsPage:
        step.value = CheckoutFlowStep.ValidationPage;
        break;
      case CheckoutFlowStep.ViewBolPage:
        step.value = CheckoutFlowStep.CheckoutDetailsPage;
        break;
      case CheckoutFlowStep.WelcomePage:
        // Already at the first step, do nothing or loop back to the last step
        break;
    }
    return step.value;
  };

  return {
    step,
    getCurrentStepComponent,
    validateStep,
    goToNextStep,
    goToPreviousStep
  };
}
